import type { Attendee, Profile } from '@tunasong/schemas'

type AttendeeSource = Pick<Profile, 'userId' | 'name'> & { email?: string }

/** An attendee from a profile. Other users' profiles carry no email; pass `email` from `useMemberEmails` when known. */
export const toAttendee = ({ userId, name, email }: AttendeeSource): Attendee => ({
  userId,
  name: name ?? email ?? 'Unnamed user',
  ...(email ? { email } : {}),
  optional: false,
})
